/**
 * useUserPermissions — S10-03
 *
 * Hook to check user permissions for admin-only features like Sites management.
 * Returns true if user is admin OR has a site_id assigned (whitelabel user).
 */
import { useUserStore } from '../stores/userStore'

export function useUserPermissions() {
  const user = useUserStore((state) => state.user)

  const canViewAdminItems = !!(user?.is_admin || user?.site_id)

  return {
    /** false, solange der Account noch nicht geladen ist (Store-User null). Admin-Seiten
     *  duerfen erst dann umleiten, sonst fliegt der Admin beim Direktaufruf/Reload raus. */
    isLoaded: user !== null,
    isAdmin: !!user?.is_admin,
    siteId: user?.site_id ?? null,
    canViewAdminItems,
  }
}
